/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Button, Row, Col, Space,
} from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';

import FormItem from '../formItem';

const Top = ({
  onSubmit,
  fields,
  extra,
  additional,
  initialValues,
  getForm,
  onExportData,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (getForm) {
      getForm(form);
    }
  }, [getForm]);
  return (
    <Form
      form={form}
      onFinish={onSubmit}
      initialValues={initialValues}
      onValuesChange={onExportData}
    >
      <Row wrap gutter={40}>
        {additional}
        {
          fields.map((f) => (f.fields?.length ? (
            <Col>
              <Form.Item name={f.name} label={f.label} style={{ marginBottom: 0 }}>
                <Row size={20} align="middle">
                  {
                    f.fields.map((cf, index) => (
                      <>
                        {index > 0 && <span style={{ margin: '0 10px 24px' }}>{f.separator}</span>}
                        <FormItem
                          mult={cf.mult}
                          form={form}
                          key={cf.name}
                          name={cf.name}
                          label={cf.label}
                          type={cf.type}
                          inputProps={{
                            ...cf.inputProps,
                            onChange: (val) => {
                              if (cf?.inputProps?.onChange) {
                                cf.inputProps.onChange(val, cf.name);
                              }
                            },
                          }}
                          labelAlign="right"
                        />
                      </>
                    ))
                  }
                </Row>
              </Form.Item>
            </Col>
          ) : (
            <Col xs={24} sm={24} md={24} lg={12} xl={f.type === 'DATE_PICKER' ? 10 : 8} xxl={f.type === 'DATE_PICKER' ? 7 : 6}>
              <FormItem mult={f.mult} form={form} name={f.name} label={f.label} type={f.type} inputProps={f.inputProps} labelAlign="right" />
            </Col>
          )))
        }
        <Form.Item style={{ marginLeft: 20 }}>
          <Space size={30}>
            <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>查询</Button>
            <Button
              onClick={() => {
                form.resetFields();
                form.submit();
                onExportData({}, {});
              }}
            >
              重置
            </Button>
          </Space>
        </Form.Item>
        {extra}
      </Row>
      {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Form.Item>
          <Space size={30}>
            <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>查询</Button>
            <Button
              onClick={() => {
                form.resetFields();
                form.submit();
                onExportData({}, {});
              }}
            >
              重置
            </Button>
          </Space>
        </Form.Item>
      </div> */}
    </Form>
  );
};

Top.propTypes = {
  onSubmit: PropTypes.func,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.string,
      inputProps: PropTypes.shape({}),
    }),
  ),
  extra: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
  additional: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
  initialValues: PropTypes.shape({}),
  getForm: PropTypes.func,
  onExportData: PropTypes.func,
};

Top.defaultProps = {
  onSubmit: () => { },
  fields: [],
  extra: null,
  additional: null,
  initialValues: {},
  getForm: () => { },
  onExportData: () => { },
};
export default Top;
